import { createVideoContentVideos } from '../store/actions/videoContentVideosActions';

export default {
  getURL: 'composeExperienceLiveUrl',
  canOpen: false,
  isSelectable: true,
  // createURL: 'appId/areaId/appContent',
  // sessionParams: ['appId', 'areaId'],
  fields: [
    {
      width: '25rem',
      attributeName: 'live_name',
      helpText: 'Live event.',
      label: 'Live name',
      canFilter: true,
    },
    {
      width: '35rem',
      attributeName: 'url',
      helpText: 'Title of the video.',
      label: 'Url',
      canFilter: true,
    },
    {
      width: '20rem',
      attributeName: 'video_type',
      helpText: 'Type of the video.',
      label: 'Video Type',
      canFilter: true,
    },
  ],
};
